var _path, _path2, _path3, _rect, _rect2, _path4, _path5, _rect3, _path6, _path7, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageOffline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 211,
    viewBox: "0 0 270 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.029 193.969C188.609 193.969 225.559 157.019 225.559 111.439C225.559 65.8585 188.609 28.9084 143.029 28.9084C97.4486 28.9084 60.4985 65.8585 60.4985 111.439C60.4985 157.019 97.4486 193.969 143.029 193.969Z",
    fill: "#F1F4FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98 111C99.1046 111 100 111.895 100 113C100 114.105 99.1046 115 98 115V111ZM2 37C0.89543 37 0 36.1046 0 35C0 33.8954 0.89543 33 2 33L2 37ZM47.1661 47.6865L45.4023 48.6293L47.1661 47.6865ZM37.3135 37.8339L38.2563 36.07H38.2563L37.3135 37.8339ZM62.6865 110.166L63.6293 108.402L63.6293 108.402L62.6865 110.166ZM52.8339 100.314L54.5977 99.3707V99.3707L52.8339 100.314ZM89 111H98V115H89V111ZM11 37H2L2 33H11L11 37ZM48 74C48 66.9617 47.9983 61.8083 47.653 57.748C47.3097 53.7126 46.638 50.9411 45.4023 48.6293L48.93 46.7437C50.5282 49.7337 51.2733 53.1151 51.6386 57.409C52.0017 61.6781 52 67.0305 52 74H48ZM11 33C17.9695 33 23.3219 32.9983 27.591 33.3614C31.8849 33.7267 35.2663 34.4718 38.2563 36.07L36.3707 39.5977C34.0589 38.362 31.2874 37.6903 27.252 37.347C23.1917 37.0017 18.0383 37 11 37L11 33ZM45.4023 48.6293C43.3511 44.7919 40.2081 41.6489 36.3707 39.5977L38.2563 36.07C42.7914 38.4941 46.5059 42.2086 48.93 46.7437L45.4023 48.6293ZM89 115C82.0305 115 76.6781 115.002 72.409 114.639C68.1151 114.273 64.7337 113.528 61.7437 111.93L63.6293 108.402C65.9411 109.638 68.7126 110.31 72.748 110.653C76.8083 110.998 81.9617 111 89 111V115ZM52 74C52 81.0383 52.0017 86.1917 52.347 90.252C52.6903 94.2874 53.362 97.0589 54.5977 99.3707L51.07 101.256C49.4718 98.2663 48.7267 94.8849 48.3614 90.591C47.9983 86.3219 48 80.9695 48 74H52ZM61.7437 111.93C57.2086 109.506 53.4941 105.791 51.07 101.256L54.5977 99.3707C56.6489 103.208 59.7919 106.351 63.6293 108.402L61.7437 111.93Z",
    fill: "#4F8CED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M235 177V155C235 138.146 235 129.72 230.955 123.666C229.204 121.046 226.954 118.796 224.334 117.045C218.28 113 209.854 113 193 113V113",
    stroke: "#4F8CED",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 106,
    width: 3,
    height: 18,
    rx: 1.5,
    transform: "rotate(90 135 106)",
    fill: "#2E396E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 117,
    width: 3,
    height: 18,
    rx: 1.5,
    transform: "rotate(90 135 117)",
    fill: "#2E396E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90 111C90 108.791 91.7909 107 94 107H100V119H94C91.7909 119 90 117.209 90 115V111Z",
    fill: "#2F6AC8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100 105C100 102.791 101.791 101 104 101H119V125H104C101.791 125 100 123.209 100 121V105Z",
    fill: "#5D93E9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 99,
    width: 3,
    height: 28,
    rx: 1.5,
    fill: "#2F6AC8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M198 111C198 108.791 196.209 107 194 107H188V119H194C196.209 119 198 117.209 198 115V111Z",
    fill: "#2F6AC8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M188 105C188 102.791 186.209 101 184 101H169V125H184C186.209 125 188 123.209 188 121V105Z",
    fill: "#5D93E9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 28,
    rx: 1.5,
    transform: "matrix(-1 0 0 1 169 99)",
    fill: "#2F6AC8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 72,
    width: 2,
    height: 10,
    rx: 1,
    fill: "#2E396E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 167.071,
    y: 77,
    width: 2,
    height: 10,
    rx: 1,
    transform: "rotate(45 167.071 77)",
    fill: "#2E396E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 173,
    y: 90,
    width: 2,
    height: 10,
    rx: 1,
    transform: "rotate(90 173 90)",
    fill: "#2E396E"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 155,
    width: 2,
    height: 10,
    rx: 1,
    transform: "rotate(-180 130 155)",
    fill: "#2E396E"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 116.929,
    y: 150,
    width: 2,
    height: 10,
    rx: 1,
    transform: "rotate(-135 116.929 150)",
    fill: "#2E396E"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 137,
    width: 2,
    height: 10,
    rx: 1,
    transform: "rotate(-90 111 137)",
    fill: "#2E396E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageOffline);
export default __webpack_public_path__ + "static/media/image-offline.ce77e55fed683e99bdaeba063630fbaf.svg";
export { ForwardRef as ReactComponent };